// Client for working-capital KPIs (/api/workcap): strip, breakdowns and targets.
import { headers, parse } from "./classificationApi";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/workcap`;
export const WC_ROLES = ["ceo", "cfo", "coo"];
export const EDIT_ROLES = ["cfo", "coo", "it_head"];
export const getSummary = () => fetch(`${BASE}/summary`, { headers: headers(null, false) }).then(parse);
export const getBreakdown = (by, window) => fetch(`${BASE}/breakdown?by=${by}&window=${window}`, { headers: headers(null, false) }).then(parse);
export const getTargets = () => fetch(`${BASE}/targets`, { headers: headers(null, false) }).then(parse);
export const putTargets = (body) => fetch(`${BASE}/targets`, { method: "PUT", headers: headers(null, true), body: JSON.stringify(body) }).then(parse);
export const days = (v) => (v == null ? "—" : `${Math.round(v)} d`);
